import axiosInstance from '../../axios-config';

const getPatientRegistrationDetailsUrl = '/api/accountsettings/patientregistrationdetails/{0}';
const changeEmailUrl = '/api/users/{userId}/changeemail?language={language}';

export const getPatientRegistrationDetails = (patientId) =>
  axiosInstance.get(getPatientRegistrationDetailsUrl.replace('{0}', patientId));

export const changeEmail = (creds, language) =>
  axiosInstance.put(changeEmailUrl
    .replace('{userId}', creds.userId)
    .replace('{language}', language),
  creds);
